import React from 'react';

/* =========================================================================  */
/* Component(s) */
/* =========================================================================  */

/**
 * @typedef {PropTypes.InferProps<typeof propTypes>} Props
 */
const IconCrown = () => {
    return (
        <svg
            fill='none'
            style={{ width: '16px', height: '14px' }}
            viewBox='0 0 16 14'
            xmlns='http://www.w3.org/2000/svg'>
            <path
                d='M7.07031 5.50995L7.50031 6.32995L7.93031 5.50995L7.50031 4.69995L7.07031 5.50995Z'
                fill='black'/>
            <path
                d='M14.002 10.74H1.00195V13.24H14.002V10.74Z'
                fill='black'/>
            <path
                d='M15.001 2.074L14.269 1.574L12.369 2.585L7.501 0L2.632 2.587L0.732 1.576L0 2.076L0.961 9.74H14.041L15.001 2.074ZM7.501 8.46L5.931 5.51L7.501 2.56L9.071 5.51L7.501 8.46Z'
                fill='black'/>
        </svg>
    );
};

/* =========================================================================  */
/* Typing and export(s) */
/* =========================================================================  */

const propTypes = {};

IconCrown.propTypes = propTypes;

export default IconCrown;
